<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd" :title="$t('add')" icon="el-icon-edit"></el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.user_code" :placeholder="$t('code_cname2')">
                        <span slot="prepend">{{$t('user')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.user_mobile">
                        <span slot="prepend">{{$t('mobile')}}{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column :label="listHeader.img_lnk" width="120px">
                        <template slot-scope="scope">
                            <myImgshow :src="scope.row.img_lnk" @onClick="$base.alertImg(scope.row.img_lnk, scope.row.user_cname)"></myImgshow>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_code" :label="listHeader.user_code" width="120px"></el-table-column>
                    <el-table-column prop="user_cname" :label="listHeader.user_cname" width="120px"></el-table-column>
                    <el-table-column width="100px" prop="user_sex_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.user_sex_cdesc" :list="user_sexs" v-model="search.user_sex"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_mobile" :label="listHeader.user_mobile" width="120px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                    <el-table-column :label="listHeader.deps" min-width="140px">
                        <template slot-scope="scope">
                            <el-tag size="small" v-for="(item2, index2) in scope.row.deps" :key="index2">{{item2.dep_cname}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :label="listHeader.roles" min-width="140px">
                        <template slot-scope="scope">
                            <el-tag type="danger" size="small" v-for="(item2, index2) in scope.row.roles" :key="index2">{{item2.role_cname}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" min-width="200px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave(scope.row)">{{$t('info')}}</a>
                            <a class="link" @click="removeUser(scope.row.u_id)">{{$t('remove_by_org')}}</a>
                            <a class="link" @click="resetPassword(scope.row)">{{$t('reset_pwd')}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myDatePicker from '../../../components/myDatePicker'
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myImgshow from '../../../components/myImgshow'
    import myDropdown from '../../../components/myDropdown'
    export default {
        name:"org-user",
        components:{
            myDatePicker,
            myPager,
            myNodata,
            myImgshow,
            myDropdown,
        },
        data:function(){
            const listHeader = {
                img_lnk: this.$t('logo_img'),
                user_code: this.$t('user_code'),
                user_cname: this.$t('user_cname'),
                user_sex_cdesc: this.$t('sex'),
                user_mobile: this.$t('mobile'),
                add_time: this.$t('add_time'),
                deps: this.$t('dep_cname'),
                roles: this.$t('role_cname'),
                listHeaderEx:{
                    img_lnk: {type:'image',width:120,height:120}
                }
            };
            return{
                self:this,
                show_subview:false,
                relist:false,
                search:{
                    search_url: "user/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    user_code:'',
                    user_mobile:'',
                    user_sex:''
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                user_sexs:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            getLoad: function() {
                var data = {};
                this.$base.showLoading();
                this.$request.sendPost("user/before-list",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.user_sexs = this.user_sexs.concat(data.sexs);
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this);
            },
            openAdd:function () {
                this.$base.linkTo('user/add');
            },
            openSave:function (item) {
                this.$base.linkTo('user/upd', {id:item.u_id});
            },
            removeUser: function (u_id) {
                let data = {
                    u_id: u_id,
                };
                let content = '您确定要讲当前用户移出本组织吗？';
                this.$base.confirm(content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("user/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                },()=>{})
            },
            resetPassword: function (item) {
                this.$base.linkTo('user/resetPwd',{id:item.u_id,user_code:item.user_code,user_cname:item.user_cname});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user.vue